import type { CauserSubjectProps } from "./causer-subject.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useCauserSubjectLink } from "./causer-subject.hook";

const { Text } = Typography;

export const CauserSubject = ({ type, model, item }: CauserSubjectProps) => {
  const { t } = useTranslation();
  const route = useCauserSubjectLink(model, item);

  if (!item) {
    if (type === "subject") return null;
    return <Text>{t("global:defaultCauserName")}</Text>;
  }

  if (!route) return <Text>{item.name}</Text>;

  return <Link to={route}>{item.name}</Link>;
};
